import { getAllErrorRoutes } from "../../routing/ErrorRoutes";
import { FAA_SUB_ROUTES, ROUTE_LABELS, ROUTE_PATHS } from "../enums/routing-enums";
import { HAT_LEG_QC_DETAILS_ABO_ROUTE } from "../../routing/SubRoutes/Hat";
/**
 * Refer to **removePeriodSelectorFromRoute** array from config file for additional
 * routes without period selector.
 */
export const ROUTES_WITHOUT_PERIOD_SELECTOR: string[] = [
  ROUTE_PATHS.EARNINGS_CALCULATOR,
  ROUTE_PATHS.FEEDBACK,
  ROUTE_PATHS.LEARN_ABOUT_CPP,
  ROUTE_PATHS.LEARN_ABOUT_CORE_PLAN,
  ROUTE_PATHS.IBO_ONBOARDING,
  ROUTE_PATHS.CBR,
  ROUTE_PATHS.BIRTHDAYS_ACTION_REPORT,
  ROUTE_PATHS.WHOS_CLOSE_ACTION_REPORT,
  ROUTE_PATHS.WHOS_NEW_ACTION_REPORT,
  `${ROUTE_PATHS.WHOS_NEW_ACTION_REPORT}/tree`,
  ROUTE_PATHS.FAA,
  ...FAA_SUB_ROUTES,
  ROUTE_PATHS.RENEWALS,
  HAT_LEG_QC_DETAILS_ABO_ROUTE,
  ROUTE_PATHS.GROUP_MANAGEMENT_DASHBOARD,
  ROUTE_PATHS.ONLINE_STATEMENTS,
  ROUTE_PATHS.RETRO_PV_INQUIRY,
  ROUTE_PATHS.SAQ_ACTION_REPORT,
  ROUTE_PATHS.FSI_ACTION_REPORT,
  ROUTE_PATHS.SOP_REPORT,
  ...getAllErrorRoutes(),
];
/**
 * Routes that hide the period selector regardless of hash.
 * Other routes in ROUTES_WITHOUT_PERIOD_SELECTOR require an exact match (path + hash).
 */
export const ROUTES_WITHOUT_PERIOD_SELECTOR_IGNORE_HASH: string[] = [
  ROUTE_PATHS.RENEWALS,
  ROUTE_PATHS.CBR,
  ROUTE_PATHS.IBO_ONBOARDING,
  ROUTE_PATHS.WHOS_CLOSE_ACTION_REPORT,
];

export const INNER_ROUTE_SHOW_PERIOD_SELECTOR: string[] = [ROUTE_PATHS.EDLOS_DOWNLINE];

export const ROUTE_TO_EXTERNAL = [
  ROUTE_LABELS.LEARN_ABOUT_CPP,
  ROUTE_LABELS.LEARN_ABOUT_CORE_PLAN,
  ROUTE_LABELS.ACADEMY,
];

// Always display dropdown items based on the ROUTE_LABEL
export const ALWAYS_DISPLAY: string[] = [
  ROUTE_LABELS.FEEDBACK,
  ROUTE_LABELS.LEARN_ABOUT_CORE_PLAN,
  ROUTE_LABELS.LOG_OUT,
];
